import PropTypes from "prop-types";
import classes from "./FormActions.module.css";

const FormActions = ({ children }) => {
    return <div className={classes.actionsContainer}>{children}</div>;
};

export default FormActions;

FormActions.propTypes = {
    children: PropTypes.node,
};
